<template>
    <div class="panel">
        <h3>Local Chat Widget</h3>

        <Checkbox v-model="chatWidget.enabled" density="compact"> Enable </Checkbox>

        <TransitionExpand>
            <div class="panel-count" v-if="chatWidget.enabled">
                <Notification icon="InfoCircle" variant="warning">
                    Remember that `chat-widget.iife.js` must be pasted in the root folder.
                </Notification>
            </div>
        </TransitionExpand>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import Checkbox from '@ui/components/FormV2/Fields/Checkbox/Checkbox.vue';
    import TransitionExpand from '@ui/components/TransitionExpand/TransitionExpand.vue';
    import Notification from '@ui/components/Notification/Notification.vue';
    import { FakeDataChatWidget } from '@/components/shared/DevPanel/DevPanel.interfaces';

    export default defineComponent({
        name: 'ChatWidgetPanel',
        components: { Checkbox, TransitionExpand, Notification },
        props: {
            chatWidget: { type: Object as PropType<FakeDataChatWidget>, required: true },
        },
    });
</script>

<style lang="scss">
    @forward './Panel.scss';
</style>
